export const GET_SETTINGS_REQUEST = 'GET_SETTINGS_REQUEST';

export const getSettingsRequest = () => ({
    type: GET_SETTINGS_REQUEST,
});
